export enum TcListFilterType {
  Client = 'client',
  Server = 'server',
  Disabled = 'disabled',
}
